import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Div = styled.div<{ financialFooterHeight: number }>`
  .table-link {
    color: #000;
    font-weight: bold;
  }

  .custom-table-row.ant-table-row-selected > .ant-table-cell {
    background-color: #fff !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-table-cell {
    font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'apple color emoji',
      'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
  }

  .type-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .ant-drawer-title {
    font-size: 20px;
  }

  .ant-drawer-header {
    background-color: #5340ff;
    border-radius: 0;
  }

  .tenant-container {
    display: flex;
  }

  .tenant-name {
    margin-left: 4px;
    font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'apple color emoji',
      'segoe ui emoji', 'Segoe UI Symbol', 'noto color emoji';
  }

  margin-bottom: ${({ financialFooterHeight }) => financialFooterHeight + 16}px;
`;

export const OpenDrawerContainer = styled.div`
  display: flex;
  width: 26px;
  height: 26px;
  border-radius: 13px;
  background-color: #f3f4f7;
  align-items: center;
  justify-content: center;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  justify-content: flex-start;
  gap: 20px;

  width: 100%;
  margin-bottom: 32px;

  @media (max-width: 617px) {
    justify-content: center;
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
`;

export const Button = styled(ButtonAntD)`
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  font-size: 20px;
`;
